module.exports = __webpack_public_path__ + "img/10.cf5ca155.jpg";